module.exports = __webpack_public_path__ + "static/media/logout.410c14a4.svg";